import React from 'react';
import PropTypes from 'prop-types';
import HtmlContent from '../HtmlContent';
import NavButton from '../../elements/NavButton';

export default class QuestionContent extends React.Component {
  constructor(props) {
    super(props);

    this.handleModalClose = this.handleModalClose.bind(this);
  }

  validateAnswer = (event) => {
    const { nextStepHandler } = this.props;
    nextStepHandler(event);
  };

  handleModalClose = () => {
    const { closeHandler } = this.props;

    closeHandler();
  };

  render() {
    const {
      content,
      dataQuery,
      nextStep
    } = this.props;
    const {
      AdventCount: {
        translations: {
          common: {
            close,
              next,
          },
        },
      },
    } = window;

    return (
      <div className="adventcount-modal">
        <HtmlContent content={content} />
        <div className="adventcount-button-row">
          <NavButton
            toStep=""
            btnLabel={close}
            direction="close"
            clickHandler={this.handleModalClose}
          />
          {dataQuery === "on" && (
              <NavButton
                  toStep={nextStep}
                  btnLabel={next}
                  direction="next"
                  clickHandler={this.validateAnswer}
              />
          )}
        </div>
      </div>
    );
  }
}

QuestionContent.propTypes = {
  content: PropTypes.string.isRequired,
  nextStep: PropTypes.string.isRequired,
  nextStepHandler: PropTypes.func.isRequired,
  closeHandler: PropTypes.func.isRequired,
};
